import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const FlagIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16 17c-1.69 0-3.05-.54-4.37-1.07A9.55 9.55 0 0 0 8 15c-2.44 0-3.31.72-3.32.73-.3.26-.73.33-1.08.17A1 1 0 0 1 3 15V3c0-.27.11-.52.29-.71C3.51 2.07 4.75 1 8 1c1.69 0 3.05.54 4.37 1.07 1.19.48 2.32.93 3.63.93 2.44 0 3.31-.72 3.32-.73.3-.26.73-.33 1.08-.17a1 1 0 0 1 .6.9v12c0 .27-.11.52-.29.71-.22.22-1.46 1.29-4.71 1.29Zm-8-4c1.69 0 3.05.54 4.37 1.07 1.19.48 2.32.93 3.63.93 1.63 0 2.56-.32 3-.54V4.61c-.72.22-1.7.39-3 .39-1.69 0-3.05-.54-4.37-1.07A9.55 9.55 0 0 0 8 3c-1.63 0-2.56.32-3 .54v9.85c.72-.22 1.7-.39 3-.39Z" />
    <path d="M4 23a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1 1 1 0 0 1 1 1v7a1 1 0 0 1-1 1Z" />
  </Icon>
));
export default FlagIcon;
